<template>

  <form @submit="submit">

    <alert ref="alert"/>

    <div class="form-group">
      <label class="sr-only" for="inputPassword">Email</label>
      <input
        v-model="password"
        type="password"
        class="form-control"
        v-bind:class="{'is-invalid': errors.password}"
        id="inputPassword"
        name="password"
        placeholder="Password"
        @keyup.enter="submit">
      <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
    </div>

    <div class="form-group">
      <label class="sr-only" for="inputPasswordVerify">Email</label>
      <input
        v-model="passwordVerify"
        type="password"
        class="form-control"
        v-bind:class="{'is-invalid': errors.passwordVerify}"
        id="inputPasswordVerify"
        name="password"
        placeholder="Password verify"
        @keyup.enter="submit">
      <div v-if="errors.passwordVerify" class="invalid-feedback">{{ errors.passwordVerify }}</div>
    </div>

    <button @click="submit" type="button" class="btn btn-primary btn-block">Confirm</button>
  </form>

</template>

<script>
import alert    from '../alert'
import { http } from '@/http'

export default {
  components: { alert },
  props:      ['defaultData'],
  data () {
    return {
      password:       null,
      passwordVerify: null,

      errors: {
        password:       null,
        passwordVerify: null
      }
    }
  },
  methods:    {
    submit (event) {
      event.preventDefault()

      if (this.hasErrors()) {
        return
      }

      let data = {
        Password:    this.password,
        IDtLanguage: this.defaultData.iDtLanguage
      }

      /* odeslani pozadavku */
      http.put(
        `User/` + this.defaultData.id,
        data
      )
        /* zpracovani pozadavku */
          .then(response => {
            this.$router.push({ name: 'Dashboard' })
            this.cleanSingUp()
          })

          .catch(e => {
            let message = 'Při odesílání požadavku došlo k chybě (' + e.message + ')'
            this.$emit('showMessage', { message: message, type: 'error' })
          })
    },
    hasErrors () {
      let hasError = false

      if (!this.password) {
        hasError             = true
        this.errors.password = 'Prosím zadejte heslo'
      }

      if (this.password !== this.passwordVerify) {
        hasError                   = true
        this.errors.password       = 'Hesla nejsou shodná'
        this.errors.passwordVerify = 'Hesla nejsou shodná'
      }

      return hasError
    }
  }
}
</script>

<style scoped>

</style>
